<script>
import CheckboxRow from '@/components/Forms/CheckboxRow'
import GwTooltipNew from '@/components/lib/GwTooltip/GwTooltipNew.vue'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'GmfSelektorRows',
  components: {
    CheckboxRow,
    GwTooltipNew,
  },
  props: {
    rows: Array,
    gameformat: Object,
    hasTitle: { type: Boolean, default: true },
  },
  emits: ['update:sub'],
  data() {
    return {}
  },
  methods: {
    openPayoutsDialog(row) {
      this.$store.dispatch(
        'router_set_dialogs',
        `payouts-dialog_tournamentid-${row.tournament_structure_id?.replaceAll('-', '+')}`,
      )
    },
    handleUpdate(ii) {
      const itemConf = this.rows.find(conf => conf.id === ii.confId)
      const item = {
        ...ii,
        conf: itemConf,
      }
      this.$emit('update:sub', item)
    },
    getSubs(v) {
      return v?.item?.conf?.subs || []
    },
    getItem(conf) {
      const activeSub = (conf.subs || []).find(sub => this.gameformat[sub.groupId] === sub.id)

      if (!activeSub) return null

      const optionsPool = conf.subs
      let options = optionsPool.map(i => i.id)

      const { subsConf } = conf

      const disabled = !subsConf?.allToBeOptions
        ? []
        : subsConf.allToBeOptions.filter(oo => !options.includes(oo))

      if (disabled?.length) {
        options = subsConf?.allToBeOptions
      }
      if (subsConf.order) {
        const { order } = subsConf
        if (order === 'asc') {
          options = options.sort((a, b) => (a < b ? -1 : 1))
        } else if (order === 'desc') {
          options = options.sort((a, b) => (a > b ? -1 : 1))
        } else {
          options = options.sort((a, b) => (order.indexOf(a) < order.indexOf(b) ? -1 : 1))
        }
      }

      if (conf.id === 'root') {
        options = ['cash', 'mtt', 'spins', 'husng']
      }

      const locks = options.map(o => optionsPool.find(l => l.id === o)?.hasLock)
      const cssClass = subsConf.id === 'tournament_phase' ? 'cherow_grid' : ''
      const hasPayouts = !!cssClass
      const cssStyle = cssClass
        ? '--columns-items-row: repeat(auto-fit, minmax(9em, 1fr));'
        : subsConf.id === 'players'
          ? '--row-wrap: wrap;'
          : subsConf.id === 'tournament_name'
            ? '--row-wrap: wrap; --checkbox-item-height: 2.4rem;'
            : '--row-wrap: wrap; max-width: 100%;'
      // let cssStyle = cssClass ? '--row-wrap: wrap; max-width:19em' : ''
      const styleCheckbox = cssClass ? ' --justify-content-checkbox-btn: flex-start;' : ''

      const selected = [activeSub.id]
      const res = {
        title: this.$t(subsConf.name || `gameformat.${subsConf.id}`),
        title_tooltip: this.getTitleTooltip(subsConf, conf, options),
        title_dialog: cssClass ? 'tournament-phase-dialog' : '',
        id: subsConf.id,
        confId: conf.id,
        getOptionName: subsConf.getOptionName,
        options,
        cssClass,
        hasAfter: hasPayouts || subsConf.guide,
        hasPayouts,
        guide: subsConf.guide,
        cssStyle,
        styleCheckbox,
        locks,
        selected,
        disabled,
        streams:
          activeSub.groupId === 'tournament_name'
            ? optionsPool.map(o => o.gameformats?.some(g => g.stream_url))
            : [],
        inaccurate_events:
          activeSub.groupId === 'tournament_name'
            ? optionsPool.map(o => this.$store.getters.gmfs_inaccurate_events.includes(o.id))
            : [],
        tournament_structure_id: conf.gameformats?.find(g => g.tournament_name === conf.id)
          ?.tournament_structure_id,
      }
      return res
    },
    getTitleTooltip(subsConf, conf, options) {
      if (subsConf.useTooltipFallbackKey && this.$te(subsConf.tooltipFallbackKey)) {
        return this.$t(subsConf.tooltipFallbackKey)
      }
      if (subsConf.getTooltipHtml) {
        return subsConf.getTooltipHtml(options)
      }
      if (subsConf.getTooltip) {
        const tooltipKey = subsConf.getTooltip(conf) || `missingtooltip_${conf.id}`
        if (this.$te(tooltipKey)) {
          return this.$t(tooltipKey, subsConf.tooltipProps || {})
        }
      } else if (this.$te(subsConf.tooltipFallbackKey)) {
        return this.$t(subsConf.tooltipFallbackKey)
      } else if (subsConf.tooltip) {
        return this.$t(subsConf.tooltip, subsConf.tooltipProps || {})
      }
      return ''
    },
    getOptionName({ option, row }) {
      const res = row.getOptionName
        ? row.getOptionName({ option, row, rows: this.rows, scope: this })
        : option.id
      return res
    },
  },
  computed: {
    l_rows() {
      return (this.rows || []).map(conf => this.getItem(conf))
    },
  },
}
</script>

<template>
  <div
    v-if="l_rows.length"
    class="gmfrows"
  >
    <div
      v-for="row in l_rows"
      :key="row.id"
      class="gmfrows_row gw_loading_text"
      :class="{ gmfrows_row_vertical: row.id === 'depth' }"
    >
      <CheckboxRow
        :item="row"
        class="gmfrows_row_checkbox-row"
        :hasTitle="hasTitle"
        :hasAny="false"
        :isSingle="true"
        :styleCheckbox="row.styleCheckbox"
        :checkboxAs="'btn'"
        style="
          --clr-btn-back: var(--clr-black-2);
          --clr-row-back: var(--clr-black-2);
          --row-wrap: var(--gmf-row-wrap);
        "
        :class="row.cssClass"
        :style="row.cssStyle"
        @update="item => handleUpdate(item)"
      >
        <template
          v-if="row.hasAfter"
          #title_after
        >
          <div
            v-if="row.hasPayouts"
            class="gw_btn gw_btn_small gw_btn_texts gw_btn_outlines clr-grey ml-auto weight_500 text-medium"
            @click="openPayoutsDialog(row)"
          >
            <i class="mdi mdi-currency-usd text-medium"></i>
            {{ $t('common.payouts') }}
          </div>
        </template>
        <template #default="v">
          <GwTooltipNew
            v-if="row.streams[v.index]"
            placement="top"
            closeOnContentHover
            :tooltip="$t('common.video_available')"
          >
            <template #opener="{ listeners }">
              <i
                class="mdi mdi-youtube mr-2"
                style="
                  font-size: 1.25rem;
                  color: rgb(254, 0, 0);
                  background: radial-gradient(
                    circle at center,
                    white 0%,
                    white 30%,
                    transparent 30%,
                    transparent 100%
                  );
                "
                v-on="listeners"
                @click="listeners.mouseenter"
              />
            </template>
          </GwTooltipNew>
          <span v-html="!v.id ? '-??-' : getOptionName({ option: v, row })" />
          <GwTooltipNew
            v-if="row.inaccurate_events[v.index]"
            placement="top"
            closeOnContentHover
            :tooltip="$t('tooltips.events_accuracy_warning')"
          >
            <template #opener="{ listeners }">
              <i
                class="mdi mdi-information ml-1"
                v-on="listeners"
                @click="listeners.mouseenter"
              />
            </template>
          </GwTooltipNew>
          <div
            v-if="row.locks[v.index]"
            class="mdi mdi-lock text-medium"
            style="position: relative; right: -0.25rem"
          ></div>
        </template>
      </CheckboxRow>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gmfrows {
  display: flex;
  flex-direction: column;
  grid-gap: 1em;
  --gmf-row-wrap: nowrap;
  max-width: 100%;
  &_vertical {
    flex-direction: row;
  }
  &_row {
    display: flex;
    &_checkbox-row {
      max-width: 100%;
    }
  }
}

@media screen and (max-width: 920px) {
  .gmfrows {
    --gmf-row-wrap: wrap;
  }
}
</style>
